export default [
  {
    path: '/balance-report-sport99',
    name: 'balance-report-sport99',
    component: () => import('@/views/report/balanceReportSport99/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.balanceReportSport99',
      resource: 'balance-report-sport99',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listBalanceReportSport99',
          active: true,
        },
      ],
    },
  },
  {
    path: '/report/parley',
    name: 'parley-report',
    component: () => import('@/views/report/parleyReport/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.parleyReport',
      resource: 'parley-report',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listParleyReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payback-commission-report',
    name: 'payback-commission-report',
    component: () => import('@/views/report/paybackCommissionReport/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.paybackCommissionReport',
      resource: 'monthly-commission-report',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.paybackCommissionReport',
          active: true,
        },
      ],
    },
  },
]
